/**
 * 生成设置区块（并发数 / Mermaid 图表 / 保存）
 */
import React from 'react';
import { SystemModelConfig } from '../types';
import NumberInput from './NumberInput';

interface GenerationSettingsSectionProps {
  modelConfig: SystemModelConfig;
  setModelConfig: (cfg: SystemModelConfig) => void;
  configSaving: boolean;
  handleSaveConfig: () => void;
}

export default function GenerationSettingsSection({
  modelConfig, setModelConfig, configSaving, handleSaveConfig,
}: GenerationSettingsSectionProps) {
  return (
    <section>
      <h3 className="text-sm font-semibold text-gray-900 mb-4">⚙️ 生成设置</h3>
      <p className="text-xs text-gray-500 mb-4">
        配置 AI 内容生成的全局参数，所有用户将共享此设置。
      </p>
      <div className="space-y-4">
        <NumberInput
          label="生成并发数"
          value={modelConfig.concurrency ?? 2}
          onChange={(v) => setModelConfig({ ...modelConfig, concurrency: v })}
          min={1}
          max={10}
        />
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Mermaid 图表默认显示</label>
          <select
            value={modelConfig.mermaid_default_view ?? 'code'}
            onChange={(e) => setModelConfig({ ...modelConfig, mermaid_default_view: e.target.value as 'code' | 'chart' })}
            className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
          >
            <option value="code">代码</option>
            <option value="chart">图表</option>
          </select>
          <p className="mt-1 text-xs text-gray-400">默认显示代码模式可提升大量图表时的页面性能</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Mermaid 导出图片质量</label>
          <select
            value={modelConfig.mermaid_export_format ?? 'svg'}
            onChange={(e) => setModelConfig({ ...modelConfig, mermaid_export_format: e.target.value as 'png' | 'svg' })}
            className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
          >
            <option value="svg">高清（2 倍分辨率）</option>
            <option value="png">标准</option>
          </select>
          <p className="mt-1 text-xs text-gray-400">Word 仅支持位图嵌入，导出时统一使用 PNG 格式，高清模式提升渲染分辨率</p>
        </div>
        <button
          onClick={handleSaveConfig}
          disabled={configSaving}
          className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-60 transition-colors"
        >
          {configSaving ? '保存中...' : '保存生成设置'}
        </button>
      </div>
    </section>
  );
}
